/**
 * /!\ This file is auto-generated.
 *
 * This is the entry point of your standalone application.
 *
 * There are multiple tags used by the editor to inject code automatically:
 *     - `wle:auto-imports:start` and `wle:auto-imports:end`: The list of import statements
 *     - `wle:auto-register:start` and `wle:auto-register:end`: The list of component to register
 */

/* wle:auto-imports:start */
import {CameraController} from './camera-controller.js';
import {AccessoriesConfigurator} from './configurator/accessories-configurator.js';
import {CarpetDescription} from './configurator/components/carpet-description.js';
import {CentreConsoleDescription} from './configurator/components/centre-console-description.js';
import {ColourDescription} from './configurator/components/colour-description.js';
import {DashFaceDescription} from './configurator/components/dash-face-description.js';
import {GrilleDescription} from './configurator/components/grille-description.js';
import {LeatherDescription} from './configurator/components/leather-description.js';
import {MaterialDescription} from './configurator/components/material-description.js';
import {PaintDescription} from './configurator/components/paint-description.js';
import {WheelDescription} from './configurator/components/wheel-description.js';
import {ExteriorConfigurator} from './configurator/exterior-configurator.js';
import {InteriorConfigurator} from './configurator/interior-configurator.js';
import {PaintConfigurator} from './configurator/paint-configurator.js';
import {WheelConfigurator} from './configurator/wheel-configurator.js';
import {SceneController} from './scene-controller.tsx';
/* wle:auto-imports:end */

export default function (engine) {
	/* wle:auto-register:start */
engine.registerComponent(CameraController);
engine.registerComponent(AccessoriesConfigurator);
engine.registerComponent(CarpetDescription);
engine.registerComponent(CentreConsoleDescription);
engine.registerComponent(ColourDescription);
engine.registerComponent(DashFaceDescription);
engine.registerComponent(GrilleDescription);
engine.registerComponent(LeatherDescription);
engine.registerComponent(MaterialDescription);
engine.registerComponent(PaintDescription);
engine.registerComponent(WheelDescription);
engine.registerComponent(ExteriorConfigurator);
engine.registerComponent(InteriorConfigurator);
engine.registerComponent(PaintConfigurator);
engine.registerComponent(WheelConfigurator);
engine.registerComponent(SceneController);
/* wle:auto-register:end */
}
